/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_MoreInputs */

const en_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const ar_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعلم المزيد`)
};

const de_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie mehr`)
};

const es_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprender más`)
};

const fr_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus`)
};

const it_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di più`)
};

const ja_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと詳しく`)
};

const ko_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더보기`)
};

const pt_br_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais`)
};

const ru_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подробнее`)
};

const th_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้เพิ่มเติม`)
};

const tr_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla bilgi edin`)
};

const zh_cn_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多`)
};

const zh_tw_learn_more = /** @type {(inputs: Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const learn_more = /** @type {((inputs?: Learn_MoreInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_MoreInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_learn_more(inputs)
	if (locale === "ar") return ar_learn_more(inputs)
	if (locale === "de") return de_learn_more(inputs)
	if (locale === "es") return es_learn_more(inputs)
	if (locale === "fr") return fr_learn_more(inputs)
	if (locale === "it") return it_learn_more(inputs)
	if (locale === "ja") return ja_learn_more(inputs)
	if (locale === "ko") return ko_learn_more(inputs)
	if (locale === "pt_br") return pt_br_learn_more(inputs)
	if (locale === "ru") return ru_learn_more(inputs)
	if (locale === "th") return th_learn_more(inputs)
	if (locale === "tr") return tr_learn_more(inputs)
	if (locale === "zh_cn") return zh_cn_learn_more(inputs)
	return zh_tw_learn_more(inputs)
});